module.exports = __webpack_public_path__ + "static/media/logo.e564a38d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 758
// module chunks = 0